import moment from 'moment';
import React, { useState } from 'react';
import Form from 'react-bootstrap/Form';
import { useSelector } from 'react-redux';
import { Info } from '../../../../../../assets/icons';
import { IReducer } from '../../../../../../redux/configureStore';
import { ITransferData } from '../../../../../../redux/duck/legado/transferApp/interface/reduxInterface';
import { Loading } from '../../../../../../shared/components/buttons/SearchButton';
import Frame from '../../../../../../shared/components/Frame';
import {
  isIspbFiducia,
  setTypeOperation,
} from '../../../../../../utils/businessRule';
import { capitalize, cpfCnpjMask } from '../../../../../../utils/masks';
import { convertToReal } from '../../../../../../utils/values';
import BankInfoModal from './components/BankInfoModal';
import Button from './components/Button';
import CreditIcon, { DebitIcon, TevIcon } from './components/Icons';
import PaginationComponent from './components/Pagination';
import TableComponent from './components/TableComponent/Modern';
import Wrapper from './components/Wrapper';

function TransferTableList() {
  const transfersDataState = useSelector(
    (reducer: IReducer) => reducer.transfersApp.transferList
  );

  const transfersState = useSelector(
    (reducer: IReducer) => reducer.transfersApp
  );

  const [bankInfoModalShow, setBankInfoModalShow] = React.useState(false);
  const [dataBankInfoModalShow, setDataBankInfoModalShow] = React.useState(
    transfersState.transferList[0]
  );

  function setBankInfoModal(props) {
    setDataBankInfoModalShow(props);
    setBankInfoModalShow(true);
  }

  // Modal: end

  // Pagination: start
  const [data] = useState(transfersDataState);
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage, setDataPerPage] = useState(10);
  const indexOfLastData = currentPage * dataPerPage;
  const indexOfFirstData = indexOfLastData - dataPerPage;
  const currentData = data.slice(indexOfFirstData, indexOfLastData);

  function paginate(pageNumber: number) {
    setCurrentPage(pageNumber);
  }
  function setItensPerPage(event: number) {
    setDataPerPage(event);
    setCurrentPage(1);
  }
  const handleChange = (event) => {
    setItensPerPage(event.target.value);
  };
  // Pagination: end

  // Partner identificator: start

  return (
    <Frame.Default
      isActive={transfersState.isActive}
      backgroundColor="#ffffff"
      padding="1rem"
      width="100%"
      margin="0"
      flexDirection="column">
      <Wrapper.TableComponents>
        <TableComponent.Frame>
          <TableComponent.HeaderRow>
            <TableComponent.Head>
              <TableComponent.Label>Status</TableComponent.Label>
              <TableComponent.Label>Parceiro</TableComponent.Label>
              <TableComponent.Label>Cliente</TableComponent.Label>
              <TableComponent.Label>CPF/CNPJ</TableComponent.Label>
              <TableComponent.Label>Valor</TableComponent.Label>
              <TableComponent.Label>Data</TableComponent.Label>
              <TableComponent.Label>Tipo de Operação</TableComponent.Label>
              <TableComponent.Label>Informações</TableComponent.Label>
            </TableComponent.Head>
          </TableComponent.HeaderRow>

          <TableComponent.Body>
            {transfersState.isLoading ? (
              <Loading justifyContent="center" />
            ) : (
              <>
                {currentData.map((transfer: ITransferData) => {
                  return (
                    <TableComponent.Row
                      key={transfer.id}
                      closedAccount={0}
                      status="">
                      <TableComponent.Data>
                        {isIspbFiducia(transfer.id_isbp_destino) &&
                          isIspbFiducia(transfer.id_ispb_origem) && <TevIcon />}
                        {isIspbFiducia(transfer.id_ispb_origem) &&
                          !isIspbFiducia(transfer.id_isbp_destino) && (
                            <CreditIcon />
                          )}
                        {isIspbFiducia(transfer.id_isbp_destino) &&
                          !isIspbFiducia(transfer.id_ispb_origem) && (
                            <DebitIcon />
                          )}
                      </TableComponent.Data>
                      <TableComponent.Data>
                        {capitalize(transfer.razao_social)}
                      </TableComponent.Data>
                      <TableComponent.Id>
                        {isIspbFiducia(transfer.id_isbp_destino)
                          ? transfer.nome_clienteCredtada
                          : transfer.nome_cliente_debito}
                      </TableComponent.Id>
                      <TableComponent.Data>
                        {isIspbFiducia(transfer.id_isbp_destino)
                          ? cpfCnpjMask(
                              String(transfer.cnpj_cpf_clienteCredtada)
                            )
                          : cpfCnpjMask(String(transfer.cnpj_cpf_debito))}
                      </TableComponent.Data>
                      <TableComponent.Data>
                        {convertToReal(Number(transfer.valor_lancamento))}
                      </TableComponent.Data>
                      <TableComponent.Data>
                        {moment(transfer?.created_at).format('DD/MM/YYYY')}
                      </TableComponent.Data>
                      <TableComponent.Data>
                        {setTypeOperation(transfer.cod_msg)}
                      </TableComponent.Data>
                      <TableComponent.Data>
                        <Wrapper.Buttons
                          style={{
                            alignContent: 'center',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}>
                          <Button.Info
                            onClick={() => setBankInfoModal(transfer)}>
                            <Info />
                          </Button.Info>
                        </Wrapper.Buttons>
                      </TableComponent.Data>
                    </TableComponent.Row>
                  );
                })}
              </>
            )}
          </TableComponent.Body>
        </TableComponent.Frame>
        <Wrapper.Pagination>
          <Form.Control
            as="select"
            onChange={handleChange}
            style={{ marginRight: '1rem' }}>
            <option key={14} value={10}>
              10
            </option>
            <option key={13} value={25}>
              25
            </option>
            <option key={12} value={50}>
              50
            </option>
            <option key={11} value={transfersState.transferList.length}>
              Todos
            </option>
          </Form.Control>
          <PaginationComponent
            dataPerPage={dataPerPage}
            totalData={data.length}
            currentPage={currentPage}
            paginate={(e) => paginate(e)}
          />
        </Wrapper.Pagination>

        <BankInfoModal
          show={bankInfoModalShow}
          onHide={() => setBankInfoModalShow(false)}
          data={dataBankInfoModalShow}
        />
      </Wrapper.TableComponents>
    </Frame.Default>
  );
}

export default TransferTableList;
